<template>
	<div :class="{'go-back-container-wrapper':true}" >
		<b-container class="go-back">
<b-nav small v-if="this.value" class="lcr-quick-nav">
<b-nav-item ref="navLcrBackToList" :class="{'no-border':true, 'nav-item-back-to-list':true}" :to="getBackToListLink"><span><b-img src="/img/lcr-quick-nav/blank.png"></b-img>Back to list</span></b-nav-item>
<b-nav-item ref="navLcrView" :class="{'no-border':selected == 'attachments','nav-item-details':true}" :to="getViewLink"><span><b-img src="/img/lcr-quick-nav/blank.png"></b-img>Details</span></b-nav-item>
<b-nav-item ref="navLcrAttachments" :class="{'no-border':selected == 'contraventions','nav-item-attachments':true}"   :to="getAttachmentsLink" ><span><b-img src="/img/lcr-quick-nav/blank.png"></b-img>Attachments <b-badge v-show="value.attachment.length > 0">{{value.attachment.length}}</b-badge></span></b-nav-item>
<b-nav-item ref="navLcrContraventions" :class="getContraventionsClass"  :to="getContraventionsLink"><span><b-img src="/img/lcr-quick-nav/blank.png"></b-img>Violations <b-badge v-show="value.contravention.length > 0">{{value.contravention.length}}</b-badge></span></b-nav-item>
<b-nav-item ref="navLcrActivity" :class="{'no-border':selected == 'edit', 'nav-item-activity':true}"  :to="getActivityLink" v-show="canGotoActivity"><span><b-img src="/img/lcr-quick-nav/blank.png"></b-img>Activity</span></b-nav-item>
<b-nav-item v-if="!$store.getters.isReadOnly()" ref="navLcrEdit" class="nav-item-edit-request no-border" :to="getEditRequestLink"><span><b-img src="/img/lcr-quick-nav/blank.png"></b-img>Edit Request</span></b-nav-item>
<b-nav-item v-if="!$store.getters.isReadOnly() && value.lcrChangeRequestId" ref="navLcrViewRequestedChanges" class="nav-item-edit-changes-requested no-border" :to="getViewRequestedChangesLink" :active="isRequestedChangesActive"><span><font-awesome-icon icon="exclamation-triangle" /> View Requested Changes</span></b-nav-item>
</b-nav>
		</b-container>
	</div>
</template>
<script>
export default {
	props: ['value', 'selected'],
	data() {
		return {
			loadedAllRefs:false,
		}
	},
	computed: {
		isRequestedChangesActive() {
			const path = this.$route.path
			var foo = (
				path.endsWith('/view-requested-changes') ||
				path.endsWith('/edit-requested-changes')
			);
			console.log(path, foo);
			return foo;
		},
		getContraventionsClass() {
			if (this.canGotoActivity) {
				if (this.selected == "activity") {
					return "nav-item-contraventions no-border";
				} else {
					return "nav-item-contraventions";
				}
			} else {
				if (this.selected == "edit") {
					return "nav-item-contraventions no-border";
				} else {
					return "nav-item-contraventions";
				}
			}
		},
		getBackToListLink() {
			// let currentPage = this.$routerStore.getters['currentRoute'];
			let lastPage = this.$routerStore.getters['getLastListPage'];
			// if (currentPage != null) {
			// 	console.log(currentPage);
			// 	if (currentPage.name == "EditContravention") {
			// 		lastPage = this.$routerStore.getters['getLastListPageOrViewRequestViolations'];
			// 	}
			// }

			if (lastPage == null) {
				return "/lane-closure-request-list";
			}
			return lastPage.path;

		},
		getViewLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/view";
			}
			return null;
		},
		getViewRequestedChangesLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/view-requested-changes";
			}
			return null;
		},
		getAttachmentsCount() {
			if (this.value) {
				if (this.value.attachment.length > 0) {
					return " (" + this.value.attachment.length + ")";
				}
			}
			return null
		},
		getContraventionsCount() {
			if (this.value) {
				if (this.value.contravention.length > 0) {
					return " (" + this.value.contravention.length + ")";
				}
			}
			return null
		},
		getEditRequestLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/edit";
			}
			return null;
		},
		getEditChangeRequestLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/edit-requested-changes";
			}
			return null;
		},
		getActivityLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/activity";
			}
			return null;
		},
		getContraventionsLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/contraventions";
			}
			return null;
		},
		getAttachmentsLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/attachments";
			}
			return null;
		},
		getDuplicateLink() {
			return "/new-lane-closure-request";
		},

		canGotoActivity() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
				return true;
			}
			return false;
		},
	},
	methods: {
	}
};
</script>
